import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ProgressReportDetails from "ProgressReportDetails";
export default store => ({
  path: ":setId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "progress-report" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [ProgressReportDetails(store)],
});
